import { endOfMonth, isSameDay, isSameMonth, isSameYear, startOfMonth, subMonths } from 'date-fns'
import { CalendarEntry } from '../types'
import { isValidDate, isValidInput } from '../validators'
import { InvalidCountInputError, InvalidDateError } from '../errors'
import {
  formatDifferentYears,
  formatDifferentMonths,
  formatSameMonthMultipleDays,
  formatSameMonthSingleDay,
  formatSameYear
} from '../formatters'
import normalizeDate from '../normalize-date'

export const getMonthsBefore = (date: Date, count: number, locale?: Locale): CalendarEntry => {
  if (!isValidDate(date)) {
    throw InvalidDateError
  }

  if (!isValidInput(count)) {
    throw InvalidCountInputError
  }

  let from = date
  let to = date
  if (count === 0) {
    from = startOfMonth(from)
  } else {
    from = startOfMonth(subMonths(date, count))
    to = endOfMonth(subMonths(to, 1))
  }

  let formatted
  if (!isSameYear(date, to)) {
    formatted = formatSameYear(from, to, locale)
  } else if (!isSameYear(from, to)) {
    formatted = formatDifferentYears(from, to, locale)
  } else if (!isSameMonth(from, to)) {
    formatted = formatDifferentMonths(from, to, locale)
  } else if (!isSameDay(from, to)) {
    formatted = formatSameMonthMultipleDays(from, to, locale)
  } else {
    formatted = formatSameMonthSingleDay(from, locale)
  }

  return {
    from: normalizeDate(from),
    to: normalizeDate(to),
    formatted
  }
}
